import { Skeleton } from "@/app/components/shadcn/skeleton";
import ProductsGridSkeleton from "./ProductsGridSkeleton";
import FilterSkeleton from "./FilterSkeleton";
import ProductFilterSystemSkeleton from "./ProductFilterSystemSkeleton";

const GenericProductsPageSkeleton = () => {
  return (
    <div className="container-main">
      {/* Breadcrumb Skeleton */}
      <div className="mb-4">
        <Skeleton className="h-4 w-48" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Sol filtre skeleton */}
        <div className="hidden lg:block lg:col-span-2">
          <FilterSkeleton />
        </div>

        {/* Main Content Skeleton */}
        <div className="col-span-1 lg:col-span-10 space-y-6">
          <div className="space-y-3">
            {/* Başlık + ürün sayısı */}
            <div className="flex items-center gap-2">
              <Skeleton className="h-7 w-40" />
              <Skeleton className="h-5 w-24" />
            </div>
            {/* Special filter chip'leri */}
            <div className="flex items-center gap-2 overflow-hidden">
              {Array.from({ length: 5 }).map((_, i) => (
                <Skeleton key={i} className="h-8 w-20 rounded-full shrink-0" />
              ))}
            </div>
            {/* Filtre bar + sıralama */}
            <ProductFilterSystemSkeleton />
          </div>

          {/* Products Grid Skeleton */}
          <ProductsGridSkeleton />
        </div>
      </div>
    </div>
  );
};

export default GenericProductsPageSkeleton;
